const themeActions = {
    SET_PRIMARY_COLOR: 'SET_PRIMARY_COLOR',
    SET_SECONDARY_COLOR: 'SET_SECONDARY_COLOR',
    SET_TEXT_COLOR: 'SET_TEXT_COLOR',
    SET_NOTIFICATIONS_COUNT: 'SET_NOTIFICATIONS_COUNT',
    SET_NOTIFICATION: 'SET_NOTIFICATION',
};

export default themeActions;
